import { useCallback, useEffect, useState } from "react";
import { getCirculars } from "../../../../services/StudentPortal/StudentCircularService";
import { handleApiError } from "../../../../utils/errorHandler";
import { unwrapList } from "../../utils/studentPortalUtils";

/**
 * Fetches the circular list once on mount; exposes a refetch for completeness.
 * Confirmed against the real backend (2026-10-22): student_id, program_id
 * and session_id are all required.
 */
export const useStudentCirculars = (studentId, programId, sessionId) => {
  const [circulars, setCirculars] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCirculars = useCallback(async () => {
    if (!studentId || !programId || !sessionId) return;
    setIsLoading(true);
    try {
      const response = await getCirculars({
        student_id: studentId,
        program_id: programId,
        session_id: sessionId,
      });
      setCirculars(unwrapList(response));
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  }, [studentId, programId, sessionId]);

  useEffect(() => {
    fetchCirculars();
  }, [fetchCirculars]);

  return { circulars, isLoading, fetchCirculars };
};
